"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FLASH_NOTIFICATION_DURATION = exports.FlashNotificationPosition = exports.FlashNotificationLevel = void 0;
var FlashNotificationLevel;
(function (FlashNotificationLevel) {
    FlashNotificationLevel["success"] = "success";
    FlashNotificationLevel["warning"] = "warning";
    FlashNotificationLevel["start"] = "start";
})(FlashNotificationLevel = exports.FlashNotificationLevel || (exports.FlashNotificationLevel = {}));
var FlashNotificationPosition;
(function (FlashNotificationPosition) {
    FlashNotificationPosition["topRight"] = "top-right";
    FlashNotificationPosition["topCenter"] = "top-center";
    FlashNotificationPosition["topLeft"] = "top-left";
    FlashNotificationPosition["bottomRight"] = "bottom-right";
    FlashNotificationPosition["bottomCenter"] = "bottom-center";
    FlashNotificationPosition["bottomLeft"] = "bottom-left";
})(FlashNotificationPosition = exports.FlashNotificationPosition || (exports.FlashNotificationPosition = {}));
exports.FLASH_NOTIFICATION_DURATION = 3000;
